import { montoBonito } from "./monto";

/**
 * "L 2,650/mes · 12 meses": lo que paga quien se inscribe en ese horario (historial de precios por fecha de arranque,
 * Esteban 2026-10-27). Vacío si el horario no tiene plan.
 */
export const precioHorario = (s: { coursePlan?: { hasPlan: boolean; billableMonths: number | null; monthlyPrice: number | null }; currencySymbol?: string } | null | undefined): string => {
	const p = s?.coursePlan;
	if (!p || !p.hasPlan || p.monthlyPrice === null || p.monthlyPrice === undefined) return "";
	const simbolo = s?.currencySymbol || "";
	const precio = (simbolo === "L" ? "L " : simbolo) + montoBonito(p.monthlyPrice) + "/mes";
	return p.billableMonths ? precio + " · " + p.billableMonths + (p.billableMonths === 1 ? " mes" : " meses") : precio;
};
